module.exports = ".mat-dialog-content>*{width:100%}#fsListContainer{height:300px;overflow:auto}"